var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white px-4 lg:px-12 sticky top-0 z-10 border-b"},[_c('nav',{staticClass:"text-sm max-w-7xl mx-auto flex whitespace-nowrap overflow-y-auto"},_vm._l((_vm.navigation),function(item){return _c('RouterLink',{key:item.label,staticClass:"px-4 inline-flex h-12 items-center justify-center",class:[
        _vm.$route.name === item.route.name
          ? 'text-blue-600 bg-gray-200'
          : 'text-gray-600 hover:bg-gray-200 hover:text-blue-900',
      ],attrs:{"to":item.route}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }